module.exports = __webpack_public_path__ + "static/media/img-axum-product-1@2x.70def793.png";